import createLabelValueOption from 'App/utils/createLabelValueOption';

import { noGroupOption, numericRiskTypeOptions } from '../constants';

function convertAssessmentQuestionToView(question) {
    return {
        ...question,
        blockedDays: Object.entries(question.attributes.blockedDays || {})
            .filter(([, value]) => !!value)
            .map(([day]) => createLabelValueOption(day)),
        attributes: {
            ...question.attributes,
            scoring_enabled: !!question.attributes.risk_config,
            risk_config: question.attributes.risk_config ? { id: question.attributes.risk_config } : null,
            numericRiskType:
                numericRiskTypeOptions.find((o) => o.value === question.attributes.numericRiskType) ||
                numericRiskTypeOptions[0],
        },
        group: question.group || noGroupOption,
    };
}

export default convertAssessmentQuestionToView;
